import { Stack, Button, Table, Text } from '@mantine/core'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { getEntityHistory } from 'app/state/ducks/entities/selectors'
import { loadEntityHistory } from 'app/state/ducks/entities/thunks'
import ExportToCsv from 'app/views/components/ExportToCsv/ExportToCsv'
import { formatDateToShow, stringToDate } from 'app/utils/util-functions'
import { entityTypeChangeOptions } from 'app/models/dropdown-options'

type Props = {
  close: any
  entityId: string
  status: string
}

export default function HistoryForm({ close, entityId, status }: Props) {
  const entityHistory = useSelector(getEntityHistory)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(loadEntityHistory(entityId, status))
  }, [entityId])

  const entityArrayObjects = function () {
    const exportObjVals = entityHistory.map((item) => {
      const exportObj: any = {}
      exportObj['Name'] = item.entity.entityName
      exportObj['Mei'] = item.entity.mei
      exportObj['Action Type'] = entityTypeChangeOptions.find((option) => option.value === item.actionType)?.label
      exportObj['Action Date'] = formatDateToShow(stringToDate(item.actionDate))
      return exportObj
    })
    return exportObjVals
  }

  return (
    <Stack w="100%">
      <div
        style={{
          backgroundColor: '#A4CAFE',
          width: '100%',
          padding: '10px',
          color: 'black',
          fontSize: '14px',
          fontWeight: 'bold',
        }}
      >
        Entity History
      </div>
      <div style={{ backgroundColor: '#E5E7EB', border: '1px solid #D1D5DB' }}>
        <Table>
          <thead>
            <tr>
              <th style={{ width: '9%' }}>
                <Text>Name</Text>
              </th>
              <th style={{ width: '9%' }}>
                <Text>Mei</Text>
              </th>
              <th style={{ width: '9%' }}>
                <Text>Action Type</Text>
              </th>
              <th style={{ width: '10%' }}>
                <Text>Action Date</Text>
              </th>
            </tr>
          </thead>
          <tbody style={{ backgroundColor: '#E5E7EB' }}>
            {entityArrayObjects() && entityArrayObjects().length > 0 &&
              entityArrayObjects().map((item, index) => (
                <tr
                  key={index}
                  style={{ border: '1px solid #D1D5DB', height: '3vw' }}
                >
                  <td>
                    <Text>
                      {item['Name']}
                    </Text>
                  </td>
                  <td>
                    <Text>{item['Mei']}</Text>
                  </td>
                  <td>
                    <Text>{item['Action Type']}</Text>
                  </td>
                  <td>
                    <Text>
                      {item['Action Date']}
                    </Text>
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginTop: '70px',
        }}
      >
        <ExportToCsv csvName='Entity History' exportObj={entityArrayObjects()} style={{
          width: '130px',
          backgroundColor: '#A4CAFE',
          color: 'black',
          fontWeight: 'bold',
          borderRadius: '8px',
        }} />

        <Button
          onClick={close}
          style={{
            width: '130px',
            backgroundColor: '#32439A',
            color: 'white',
            fontWeight: 'bold',
            borderRadius: '8px',
          }}
        >
          Exit
        </Button>
      </div>
    </Stack>
  )
}
